<!-- Footer -->
<template>
  <footer class="bg-primaryColor shadow-sm static bottom-0">
    <div class="w-full mx-auto p-3 md:py-6">
      <div class="sm:flex sm:items-center sm:justify-between">
        <ul
          class="flex flex-wrap items-center mb-5 text-sm font-medium text-white sm:mb-0"
        >
          <li>
            <router-link to="/impressum" class="hover:underline me-4 md:me-6"
              >Impressum</router-link
            >
          </li>
          <li>
            <router-link to="/datenschutz" class="hover:underline me-4 md:me-6"
              >Datenschutzerklärung</router-link
            >
          </li>
          <li>
            <router-link to="/kontakt" class="hover:underline me-4 md:me-6"
              >Kontakt</router-link
            >
          </li>
          <li>
            <router-link to="/links" class="hover:underline me-4 md:me-6">Links</router-link>
          </li>
          <li>
            <router-link to="/standorte" class="hover:underline me-4 md:me-6">Standorte</router-link>
          </li>
        </ul>

        <!--
          Versionsangabe für die Fehlersuche: Sagt jemand "bei mir geht etwas
          nicht", steht hier, welchen Stand die Person tatsächlich sieht.
          Der Wert kommt beim Build aus der package.json (siehe vue.config.js)
          und wird nicht hier gepflegt.
        -->
        <p class="text-xs text-white/50 select-all">Version {{ version }}</p>
      </div>
    </div>
  </footer>
</template>

<script setup>
const version = process.env.VUE_APP_VERSION || "?";
</script>
